import {
  FETCH_DEVICEINFO_LOADING,
  FETCH_DEVICEINFO_SUCCESS,
  FETCH_DEVICEINFO_FAILED,
  FETCH_DEVICEONOFF_SUCCESS,
  FETCH_DEVICECENTER_SUCCESS,
  FETCH_DEVICESUBDEVICE_SUCCESS,
} from "../actions/queryDevice";

const defVal = {
  loading: false,
  deviceInfo: {},
  deviceOnoffList: [],
  deviceOnoffListTotal: 0,
  centerList: [],
  subList: [],
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_DEVICEINFO_LOADING:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_DEVICEINFO_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        deviceInfo: action.deviceInfo,
      });
    case FETCH_DEVICEINFO_FAILED:
      return Object.assign({}, state, {
        loading: false,
      });
    case FETCH_DEVICEONOFF_SUCCESS:
      return Object.assign({}, state, {
        deviceOnoffList: action.deviceOnoffList,
        deviceOnoffListTotal: action.deviceOnoffListTotal,
      });
    case FETCH_DEVICECENTER_SUCCESS:
      return Object.assign({}, state, {
        centerList: action.centerList,
      });
    case FETCH_DEVICESUBDEVICE_SUCCESS:
      return Object.assign({}, state, {
        subList: action.subList,
      });

    default:
      return state;
  }
};
